import React, { useState, useMemo, useEffect } from "react";
import CardPayrollSettingUX from "./CardPayrollSettingUX";
import { Input, Button, Icon, Modal, Dropdown, FormField } from "semantic-ui-react";
import { RunSequence, SetProp, BTN_ACTS, CARD_NAME } from "./sequence/Payroll";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import moment from "moment";

type CardPayrollSettingProps = {
  onEvent: (e: any) => any;
  setProp: SetProp;
  buttonLoadCheck?: any;
  errorMessage?: any;
  successMessage?: any;
  PayrollSequence: any;
  runSequence: RunSequence;
  masterOptions: any;
  languageUX?: any;
};

const CardPayrollSetting = (props: CardPayrollSettingProps) => {
  console.log("PayrollSeting props:", props);

  useEffect(() => {
    props.runSequence({ sequence: "Payroll", restart: true });
  }, []);

  const [taxIdDigits, setTaxIdDigits] = useState<string[]>(Array(13).fill(""));

  const onChangeTaxId = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const input = e.target.value;
    const digit = input.replace(/\D/g, "").slice(0, 1);
    const updated = [...taxIdDigits];
    updated[index] = digit;
    setTaxIdDigits(updated);

    if (digit && index < 12) {
      const nextInput = document.getElementById(
        `CardPayrollUX-TaxID-${index + 1}`
      ) as HTMLInputElement | null;
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const onKeyDownTaxId = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && taxIdDigits[index] === "" && index > 0) {
      const prevInput = document.getElementById(
        `CardPayrollUX-TaxID-${index - 1}`
      ) as HTMLInputElement | null;
      if (prevInput) {
        prevInput.focus();
        const updated = [...taxIdDigits];
        updated[index - 1] = "";
        setTaxIdDigits(updated);
        e.preventDefault();
      }
    }
  };

  const [socialSecurityDigits, setSocialSecurityDigits] = useState<string[]>(Array(10).fill(""));

  const onChangeSocialSecurity = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let digit = e.target.value;
    digit = digit.replace(/\D/g, "").slice(0, 1);
    setSocialSecurityDigits((prev) => {
      const updated = [...prev];
      updated[index] = digit;
      return updated;
    });

    if (digit && index < 9) {
      const nextInput = document.getElementById(
        `SocialSecurity-Input-${index + 1}`
      ) as HTMLInputElement | null;
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const onKeyDownSocialSecurity = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && socialSecurityDigits[index] === "" && index > 0) {
      const prevInput = document.getElementById(
        `SocialSecurity-Input-${index - 1}`
      ) as HTMLInputElement | null;
      if (prevInput) {
        prevInput.focus();
        setSocialSecurityDigits((prev) => {
          const updated = [...prev];
          updated[index - 1] = "";
          return updated;
        });
        e.preventDefault();
      }
    }
  };

  const [emailList, setEmailList] = useState<string[]>([""]);
  const [faxList, setFaxList] = useState<PhoneNumber[]>([]);
  const [mobileList, setMobileList] = useState<PhoneNumber[]>([]);
  const [postalCode, setPostalCode] = useState("");
  const [selectedBankAccountId, setSelectedBankAccountId] = useState<number | null>(null);
  const [bankAccountDigits, setBankAccountDigits] = useState<string[]>(Array(10).fill(""));

  const onChangeBankAccount = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const input = e.target.value;
    const digit = input.replace(/\D/g, "").slice(0, 1);

    const updated = [...bankAccountDigits];
    updated[index] = digit;
    setBankAccountDigits(updated);

    if (digit && index < bankAccountDigits.length - 1) {
      const nextInput = document.getElementById(
        `BankAccount-Input-${index + 1}`
      ) as HTMLInputElement | null;
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const onKeyDownBankAccount = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && bankAccountDigits[index] === "" && index > 0) {
      const prevInput = document.getElementById(
        `BankAccount-Input-${index - 1}`
      ) as HTMLInputElement | null;
      if (prevInput) {
        prevInput.focus();
        const updated = [...bankAccountDigits];
        updated[index - 1] = "";
        setBankAccountDigits(updated);
        e.preventDefault();
      }
    }
  };

  const handleBankAccountChange = (_: any, { value }: any) => {
    setSelectedBankAccountId(value);

    const selectedAccount = props.PayrollSequence?.bankAccount?.find(
      (acc: any) => acc.id === value
    );

    if (selectedAccount?.bank_account_number) {
      const digitsOnly = selectedAccount.bank_account_number.replace(/\D/g, "").slice(0, 20);
      const digitsArray = digitsOnly.split("");
      const targetLength = digitsArray.length < 10 ? 10 : digitsArray.length;
      while (digitsArray.length < targetLength) digitsArray.push("");
      setBankAccountDigits(digitsArray);
    } else {
      setBankAccountDigits(Array(10).fill(""));
    }
  };

  const [openAddPaymentModal, setOpenAddPaymentModal] = useState(false);

  const renderAddPaymentButton = () => (
    <Button
      id="CardPayRollUX-Button-203"
      color="blue"
      style={{
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px 12px",
        height: "40px",
        fontWeight: "bold",
        gap: "8px",
        marginBottom: "5px",
      }}
      onClick={() => setOpenAddPaymentModal(true)}
    >
      <Icon name="plus" />
      Add New Payment Method
    </Button>
  );

  const [bank, setBank] = useState<number | undefined>(undefined);
  type BankAccountType =
    | "SAVINGS_ACCOUNT"
    | "FIXED_DEPOSIT_ACCOUNT"
    | "MONTHLY_FIXED_DEPOSIT_ACCOUNT"
    | "CURRENT_ACCOUNT"
    | "INTERNATIONAL_CURRENCY_ACCOUNT";
  const [bankType, setBankType] = useState<BankAccountType | "">("");
  const [bankName, setBankName] = useState("");
  const [bankNumber, setBankNumber] = useState("");

  const [filteredAndSearchedData, setFilteredAndSearchedData] = useState<any[]>([]);

  console.log("filtered data" + filteredAndSearchedData);

  function getTodayString() {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, "0");
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const organizationFromOptions = [
    { id: "COMPANY_LIMITED", value: "COMPANY_LIMITED", text: "Company Limited" },
    {
      id: "PUBLIC_COMPANY_LIMITED",
      value: "PUBLIC_COMPANY_LIMITED",
      text: "Public Company Limited",
    },
    { id: "LIMITED_PARTNERSHIP", value: "LIMITED_PARTNERSHIP", text: "Limited Partnership" },
    { id: "FOUNDATION", value: "FOUNDATION", text: "Foundation" },
    { id: "ASSOCIATION", value: "ASSOCIATION", text: "Association" },
    { id: "JOINT_VENTURE", value: "JOINT_VENTURE", text: "Joint Venture" },
    { id: "OTHERS", value: "OTHERS", text: "Others" },
  ];

  const businessTypeOptions = [
    { id: "HEALTH_CARE_SERVICES", value: "HEALTH_CARE_SERVICES", text: "Health Care Services" },
    { id: "FOOD_AND_BEVERAGE", value: "FOOD_AND_BEVERAGE", text: "Food & Beverage" },
    { id: "FASHION", value: "FASHION", text: "Fashion" },
    {
      id: "HOME_AND_OFFICE_PRODUCTS",
      value: "HOME_AND_OFFICE_PRODUCTS",
      text: "Home & Office Products",
    },
    {
      id: "PERSONAL_PRODUCTS_AND_PHARMACEUTICALS",
      value: "PERSONAL_PRODUCTS_AND_PHARMACEUTICALS",
      text: "Personal Products & Pharmaceuticals",
    },
    { id: "BANKING", value: "BANKING", text: "Banking" },
    { id: "FINANCE_AND_SECURITIES", value: "FINANCE_AND_SECURITIES", text: "Finance & Securities" },
    { id: "INSURANCE", value: "INSURANCE", text: "Insurance" },
    { id: "AUTOMOTIVE", value: "AUTOMOTIVE", text: "Automotive" },
    {
      id: "INDUSTRIAL_MATERIALS_AND_MACHINE",
      value: "INDUSTRIAL_MATERIALS_AND_MACHINE",
      text: "Industrial Materials & Machine",
    },
    { id: "PACKAGING", value: "PACKAGING", text: "Packaging" },
    {
      id: "PAPER_AND_PRINTING_MATERIALS",
      value: "PAPER_AND_PRINTING_MATERIALS",
      text: "Paper & Printing Materials",
    },
    {
      id: "PETROCHEMICALS_AND_CHEMICALS",
      value: "PETROCHEMICALS_AND_CHEMICALS",
      text: "Petrochemicals &  Chemicals",
    },
    {
      id: "STEEL_AND_METAL_PRODUCTS",
      value: "STEEL_AND_METAL_PRODUCTS",
      text: "Steel and Metal Products",
    },
    {
      id: "CONSTRUCTION_MATERIALS",
      value: "CONSTRUCTION_MATERIALS",
      text: "Construction Materials",
    },
    { id: "CONSTRUCTION_SERVICES", value: "CONSTRUCTION_SERVICES", text: "Construction Services" },
    { id: "PROPERTY_DEVELOPMENT", value: "PROPERTY_DEVELOPMENT", text: "Property Development" },
    {
      id: "PROPERTY_FUND_AND_REAL_ESTATE_INVESTMENT_TRUSTS",
      value: "PROPERTY_FUND_AND_REAL_ESTATE_INVESTMENT_TRUSTS",
      text: "Property Fund & Real Estate Investment Trusts",
    },
    { id: "ENERGY_AND_UTILITIES", value: "ENERGY_AND_UTILITIES", text: "Energy & Utilities" },
    { id: "MINING", value: "MINING", text: "Mining" },
    { id: "COMMERCE", value: "COMMERCE", text: "Commerce" },
    { id: "MEDIA_AND_PUBLISHING", value: "MEDIA_AND_PUBLISHING", text: "Media & Publishing" },
    { id: "PROFESSIONAL_SERVICES", value: "PROFESSIONAL_SERVICES", text: "Professional Services" },
    { id: "TOURISMS_AND_LEISURE", value: "TOURISMS_AND_LEISURE", text: "Tourisms & Leisure" },
    {
      id: "TRANSPORTATION_AND_LOGISTICS",
      value: "TRANSPORTATION_AND_LOGISTICS",
      text: "Transportation & Logistics",
    },
    { id: "ELECTRONIC_COMPONENTS", value: "ELECTRONIC_COMPONENTS", text: "Electronic Components" },
    {
      id: "INFORMATION_AND_COMMUNICATION_TECHNOLOGY",
      value: "INFORMATION_AND_COMMUNICATION_TECHNOLOGY",
      text: "Information & Communication Technology",
    },
  ];

  const hospitalSizeOptions = [
    {
      id: "SMALL_HOSPITAL",
      value: "SMALL_HOSPITAL",
      text: "Small hospitals contain fewer than 100 beds",
    },
    {
      id: "MEDIUM_HOSPITAL",
      value: "MEDIUM_HOSPITAL",
      text: "Medium hospitals contain between 100 to 499 beds",
    },
    {
      id: "LARGE_HOSPITAL",
      value: "LARGE_HOSPITAL",
      text: "Large hospitals contain at least 500 or more beds",
    },
    { id: "NULL", value: null, text: "ไม่ระบุ" },
  ];

  const phoneCountryCodeOptions = [
    { id: 1, value: "+66", text: "+66 (Thailand)" },
    { id: 2, value: "+1", text: "+1 (USA)" },
    { id: 3, value: "+44", text: "+44 (UK)" },
    { id: 4, value: "+81", text: "+81 (Japan)" },
    { id: 5, value: "+86", text: "+86 (China)" },
    { id: 6, value: "+61", text: "+61 (Australia)" },
    { id: 7, value: "+91", text: "+91 (India)" },
  ];

  const payRunDateOptions = Array.from({ length: 29 }, (_, i) => {
    const day = i + 1;

    if (day >= 29) {
      return {
        id: day,
        text: "วันสุดท้ายของเดือน",
        value: 99,
      };
    }

    return {
      id: day,
      text: day.toString(),
      value: day,
    };
  });

  const bankAccountTypeOptions = [
    {
      key: "SAVINGS_ACCOUNT",
      text: "บัญชีเงินฝากออมทรัพย์ (Savings Account)",
      value: "SAVINGS_ACCOUNT",
    },
    {
      key: "FIXED_DEPOSIT_ACCOUNT",
      text: "บัญชีเงินฝากประจำ (Fixed Deposit Account)",
      value: "FIXED_DEPOSIT_ACCOUNT",
    },
    {
      key: "MONTHLY_FIXED_DEPOSIT_ACCOUNT",
      text: "บัญชีเงินฝากประจำรายเดือนแบบปลอดภาษี",
      value: "MONTHLY_FIXED_DEPOSIT_ACCOUNT",
    },
    {
      key: "CURRENT_ACCOUNT",
      text: "บัญชีเงินฝากกระแสรายวัน หรือบัญชีเงินฝากเดินสะพัด (Current Account)",
      value: "CURRENT_ACCOUNT",
    },
    {
      key: "INTERNATIONAL_CURRENCY_ACCOUNT",
      text: "บัญชีเงินตราระหว่างประเทศ",
      value: "INTERNATIONAL_CURRENCY_ACCOUNT",
    },
  ];

  const [isInitializing, setIsInitializing] = useState(false);

  const handleCountryChange = async (_e: any, { value }: any) => {
    if (isInitializing) return;

    setPayrollDetailSetting((prev) => ({
      ...prev,
      country: value,
      province: null,
      sub_district: null,
      city: null,
      postal_code: "",
    }));
    await props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_COUNTRY_CHANGE",
      country: value,
    });
  };

  const handleProvinceChange = async (_e: any, { value }: any) => {
    if (isInitializing) return;

    setPayrollDetailSetting((prev) => ({
      ...prev,
      province: value,
      sub_district: null,
      city: null,
      postal_code: "",
    }));
    await props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_PROVINCE_CHANGE",
      province: value,
    });
  };

  const handleDistrictChange = async (_e: any, { value }: any) => {
    if (isInitializing) return;

    setPayrollDetailSetting((prev) => ({
      ...prev,
      sub_district: value,
      city: null,
      postal_code: "",
    }));
    await props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_DISTRICT_CHANGE",
      district: value,
    });
  };

  const handleCityChange = async (_e: any, { value }: any) => {
    if (isInitializing) return;

    const selectedCity = props.PayrollSequence?.cityList?.find(
      (item: any) => String(item.value) === String(value)
    );
    const zipcode = selectedCity?.zipcode ?? "";
    setPayrollDetailSetting((prev) => ({
      ...prev,
      city: value,
      postal_code: zipcode,
    }));
    setPostalCode(zipcode);
    await props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_CITY_CHANGE",
      city: value,
    });
  };

  const [showSnack, setShowSnack] = useState(true);

  useEffect(() => {
    if (props.errorMessage?.[CARD_NAME] || props.successMessage?.[CARD_NAME]) {
      setShowSnack(true);
    }
  }, [props.errorMessage?.[CARD_NAME], props.successMessage?.[CARD_NAME]]);

  const handleSnackClose = (_event?: any, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setShowSnack(false);
    props.setProp(`errorMessage.${CARD_NAME}`, null);
    props.setProp(`successMessage.${CARD_NAME}`, null);
  };

  console.log("SUCCESS", props.successMessage?.[CARD_NAME]);

  const handleEditDetailSetting = (
    _e: any,
    { value }: any,
    detailSetting: { id: number; [key: string]: any }
  ) => {
    const taxId = taxIdDigits.join("");
    const socialSecurityId = socialSecurityDigits.join("");
    const organization_form = detailSetting.organization_form ?? null;
    const business_type = detailSetting.business_type ?? null;
    const hospital_name_th = detailSetting.hospital_name_th ?? "";
    const hospital_name_en = detailSetting.hospital_name_en ?? "";
    const pay_run_date = detailSetting.pay_run_date ?? null;

    const isTaxIdValid = taxId.trim().length === 13;

    const newErrors: { [key: string]: boolean } = {
      tax_id: !isTaxIdValid,
      organization_form: organization_form === null,
      business_type: business_type === null,
      hospital_name_th: hospital_name_th.trim() === "",
      hospital_name_en: hospital_name_en.trim() === "",
      pay_run_date: pay_run_date === null,
    };

    const isValid =
      isTaxIdValid &&
      organization_form !== null &&
      business_type !== null &&
      hospital_name_th.trim() !== "" &&
      hospital_name_en.trim() !== "" &&
      pay_run_date !== null;

    setFieldErrors(newErrors);

    if (!isValid) {
      console.warn("Validation failed, cannot save:", newErrors);
      alert("Please fill all required fields (*) before saving.");
      return;
    }

    const updatedDetailSetting = {
      ...detailSetting,
      tax_id: taxId,
      emails: emailList,
      mobile_numbers: mobileList,
      faxs: faxList,
      social_security_id: socialSecurityId,
      postal_code: payrollDetailSetting.postal_code,
      country: payrollDetailSetting.country,
      province: payrollDetailSetting.province,
      city: payrollDetailSetting.city,
      sub_district: payrollDetailSetting.sub_district,
      employer_maximum_amount:
        payrollDetailSetting.employer_maximum_amount &&
        payrollDetailSetting.employer_maximum_amount !== ""
          ? parseFloat(String(payrollDetailSetting.employer_maximum_amount)).toFixed(2)
          : "0.00",
      employee_maximum_amount:
        payrollDetailSetting.employee_maximum_amount &&
        payrollDetailSetting.employee_maximum_amount !== ""
          ? parseFloat(String(payrollDetailSetting.employee_maximum_amount)).toFixed(2)
          : "0.00",
      employer_social_security_rate:
        payrollDetailSetting.employer_social_security_rate &&
        payrollDetailSetting.employer_social_security_rate !== ""
          ? parseFloat(String(payrollDetailSetting.employer_social_security_rate)).toFixed(2)
          : "0.00",
      employee_social_security_rate:
        payrollDetailSetting.employee_social_security_rate &&
        payrollDetailSetting.employee_social_security_rate !== ""
          ? parseFloat(String(payrollDetailSetting.employee_social_security_rate)).toFixed(2)
          : "0.00",
    };

    setPostalCode(updatedDetailSetting.postal_code);

    console.log("Editing detail setting data:", detailSetting, "with value:", updatedDetailSetting);
    setShowSuccessModal(true);

    props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_EDIT_DETAIL_SETTING",
      setting: updatedDetailSetting,
    });
  };

  const bankOptions = (props.PayrollSequence?.bankList ?? []).map((bank: any) => ({
    key: bank.id,
    text: bank.name,
    value: bank.id,
  }));

  const bankAccountOptions = (props.PayrollSequence?.bankAccount ?? []).map((account: any) => {
    const bank = props.PayrollSequence?.bankList?.find((b: any) => b.id === account.bank);
    const accountTypeMap: Record<string, string> = {
      SAVINGS_ACCOUNT: "Savings Account",
      FIXED_DEPOSIT_ACCOUNT: "Fixed Deposit Account",
      MONTHLY_FIXED_DEPOSIT_ACCOUNT: "Monthly Fixed Deposit Account",
      CURRENT_ACCOUNT: "Current Account",
      INTERNATIONAL_CURRENCY_ACCOUNT: "International Currency Account",
    };

    return {
      key: account.id,
      value: account.id,
      text: `${bank?.name} ${accountTypeMap[account.bank_account_type]} ${
        account.bank_account_number
      }`,
    };
  });

  const [bankFieldErrors, setBankFieldErrors] = useState<{
    bank?: boolean;
    bank_account_type?: boolean;
    bank_account_name?: boolean;
    bank_account_number?: boolean;
  }>({});

  const [localError, setLocalError] = useState<string | null>(null);
  const [submittedActionKey, setSubmittedActionKey] = useState<string | null>(null);

  const handleSubmitBankAccount = (_e: any) => {
    const isBankFilled = typeof bank === "number" && !Number.isNaN(bank);
    const isBankTypeFilled = bankType !== null && bankType !== undefined && bankType !== "";
    const isBankNameFilled = bankName.trim() !== "";
    const isBankNumberFilled = bankNumber.trim() !== "";

    const newErrors = {
      bank: !isBankFilled,
      bank_account_type: !isBankTypeFilled,
      bank_account_name: !isBankNameFilled,
      bank_account_number: !isBankNumberFilled,
    };

    setBankFieldErrors(newErrors);

    const isValid = Object.values(newErrors).every((error) => error === false);

    if (!isValid) {
      alert("Please fill all required fields (*) before saving.");
      return;
    }

    if (bankNumber.length >= 20) {
      alert("เลขที่บัญชีธนาคารต้องมีความยาวไม่เกิน 20 หลักเท่านั้น");
      return;
    }

    const data = {
      bank,
      bank_account_type: bankType,
      bank_account_name: bankName,
      bank_account_number: bankNumber,
    };

    setSubmittedActionKey(BTN_ACTS.HANDLE_SUBMIT_BANK_ACCOUNT);

    props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_SUBMIT_BANK_ACCOUNT",
      account: data,
    });
  };

  useEffect(() => {
    if (!submittedActionKey) return;

    const status = props.buttonLoadCheck?.[submittedActionKey];
    const rawError = props.errorMessage?.[CARD_NAME];

    if (status === "SUCCESS") {
      resetBankAccountFormFields();
      setBankFieldErrors({});
      setLocalError(null);
      setOpenAddPaymentModal(false);
      setSubmittedActionKey(null);
    }

    if (rawError) {
      const message =
        typeof rawError === "object" && rawError.non_field_errors?.length > 0
          ? rawError.non_field_errors.join(", ")
          : String(rawError);
      setLocalError(message);
      alert(message);
      setSubmittedActionKey(null);
    }
  }, [props.buttonLoadCheck, props.errorMessage, submittedActionKey]);

  const resetBankAccountFormFields = () => {
    setBank(undefined);
    setBankType("");
    setBankName("");
    setBankNumber("");
    setLocalError(null);
  };

  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: boolean }>({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSubmitDetailSetting = (_e: any) => {
    const taxId = taxIdDigits.join("");
    const socialSecurityId = socialSecurityDigits.join("");
    const {
      organization_form,
      business_type,
      hospital_name_th,
      hospital_name_en,
      pay_run_date,
      employer_maximum_amount,
      employee_maximum_amount,
      employer_social_security_rate,
      employee_social_security_rate,
    } = payrollDetailSetting;

    const isTaxIdValid = taxId.trim().length === 13;

    const newErrors: { [key: string]: boolean } = {
      tax_id: !isTaxIdValid,
      organization_form: organization_form === null,
      business_type: business_type === null,
      hospital_name_th: hospital_name_th.trim() === "",
      hospital_name_en: hospital_name_en.trim() === "",
      pay_run_date: pay_run_date === null,
    };

    const isValid =
      isTaxIdValid &&
      organization_form !== null &&
      business_type !== null &&
      hospital_name_th.trim() !== "" &&
      hospital_name_en.trim() !== "" &&
      pay_run_date !== null;

    setFieldErrors(newErrors);

    if (!isValid) {
      alert("Please fill all required fields (*) before saving.");
      return;
    }

    const data = {
      ...payrollDetailSetting,
      tax_id: taxId,
      emails: emailList,
      mobile_numbers: mobileList,
      faxs: faxList,
      postal_code: postalCode,
      country: payrollDetailSetting.country,
      province: payrollDetailSetting.province,
      city: payrollDetailSetting.city,
      sub_district: payrollDetailSetting.sub_district,
      social_security_id: socialSecurityId,
      employer_maximum_amount: parseFloat(employer_maximum_amount?.toString() ?? "0").toFixed(2),
      employee_maximum_amount: parseFloat(employee_maximum_amount?.toString() ?? "0").toFixed(2),
      employer_social_security_rate: parseFloat(
        employer_social_security_rate?.toString() ?? "0"
      ).toFixed(2),
      employee_social_security_rate: parseFloat(
        employee_social_security_rate?.toString() ?? "0"
      ).toFixed(2),
      bank_account_for_pay_run: selectedBankAccountId!,
    };

    console.log("Submitting payroll detail setting", data);

    props.runSequence({
      sequence: "Payroll",
      action: "HANDLE_SUBMIT_DETAIL_SETTING",
      setting: data,
    });

    setPostalCode(data.postal_code);

    setShowSuccessModal(true);

    setOpenAddPaymentModal(false);
    resetBankAccountFormFields();
  };

  type PhoneNumber = {
    country_code: string;
    number: string;
  };

  const normalizePhoneNumberList = (list: (string | PhoneNumber)[]): PhoneNumber[] => {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item) =>
      typeof item === "string"
        ? { country_code: "", number: item }
        : { country_code: item.country_code || "", number: item.number || "" }
    );
  };

  type PayrollDetailSetting = {
    tax_id: string;
    organization_form: string | null;
    business_type: string | null;
    hospital_name_th: string;
    hospital_name_en: string;
    hospital_size: string | null;
    emails: string[];
    mobile_numbers: PhoneNumber[];
    faxs: PhoneNumber[];
    website: string;
    address_th: string;
    address_en: string;
    country: number | null;
    province: number | null;
    city: number | null;
    sub_district: number | null;
    postal_code: string;
    social_security_id: string;
    employer_social_security_rate: string | number;
    employee_social_security_rate: string | number;
    employer_maximum_amount: string | number;
    employee_maximum_amount: string | number;
    bank_account_for_pay_run: number | null;
    pay_run_date: number | null;
    edited_at: string | null;
    edited_by: string | number | undefined;
  };

  const [payrollDetailSetting, setPayrollDetailSetting] = useState<PayrollDetailSetting>({
    tax_id: "",
    organization_form: null,
    business_type: null,
    hospital_name_th: "",
    hospital_name_en: "",
    hospital_size: null,
    emails: [],
    mobile_numbers: [],
    faxs: [],
    website: "",
    address_th: "",
    address_en: "",
    country: null,
    province: null,
    city: null,
    sub_district: null,
    postal_code: "",
    social_security_id: "",
    employer_social_security_rate: "",
    employee_social_security_rate: "",
    employer_maximum_amount: "",
    employee_maximum_amount: "",
    bank_account_for_pay_run: null,
    pay_run_date: null,
    edited_at: null,
    edited_by: "",
  });

  const handleFetchUserList = (pk: number) => {
    props.runSequence({
      sequence: "Payroll",
      action: "FETCH_USER_LIST",
      pk: pk,
    });
  };

  useEffect(() => {
    if (payrollDetailSetting?.mobile_numbers) {
      const normalizedMobile = normalizePhoneNumberList(payrollDetailSetting.mobile_numbers);
      setMobileList(
        normalizedMobile.length > 0 ? normalizedMobile : [{ country_code: "", number: "" }]
      );
    } else {
      setMobileList([{ country_code: "", number: "" }]);
    }

    if (payrollDetailSetting?.faxs) {
      const normalizedFax = normalizePhoneNumberList(payrollDetailSetting.faxs);
      setFaxList(normalizedFax.length > 0 ? normalizedFax : [{ country_code: "", number: "" }]);
    } else {
      setFaxList([{ country_code: "", number: "" }]);
    }
  }, [payrollDetailSetting?.mobile_numbers, payrollDetailSetting?.faxs]);

  const renderFieldError = (field: keyof typeof fieldErrors) =>
    fieldErrors[field] ? (
      <div style={{ color: "red", fontSize: "15px", marginRight: "5px" }}>
        Please fill in this field
      </div>
    ) : null;

  const renderBankFieldError = (fieldErrors: Record<string, boolean>, field: string) =>
    fieldErrors[field] ? (
      <div style={{ color: "red", fontSize: "15px", marginRight: "5px" }}>
        Please fill in this field
      </div>
    ) : null;

  const handleOnChangeText = (field: keyof PayrollDetailSetting) => (_: any, data: any) => {
    const newValue = data.value.slice(0, 500);
    setPayrollDetailSetting((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleOnChangeDropdown = (field: keyof PayrollDetailSetting) => (_: any, data: any) => {
    if (data?.value !== undefined) {
      setPayrollDetailSetting((prev) => ({ ...prev, [field]: data.value }));
    }
  };

  const handleOnChangeCommaList = (field: keyof PayrollDetailSetting) => (_: any, data: any) => {
    if (!data?.value) {
      return;
    }
    const list = data.value.split(",").map((v: string) => v.trim());
    setPayrollDetailSetting((prev) => ({ ...prev, [field]: list }));
  };

  const handleOnChangeInteger = (field: keyof PayrollDetailSetting) => (_: any, data: any) => {
    const value = data.value.replace(/\D/g, "");
    setPayrollDetailSetting((prev) => ({ ...prev, [field]: value }));
  };

  const handleOnChangeNumber = (field: keyof PayrollDetailSetting) => (_: any, data: any) => {
    const value = data.value.replace(/[^0-9.]/g, "");
    setPayrollDetailSetting((prev) => ({ ...prev, [field]: value }));
  };

  const handleOnChangePercentage =
    (field: keyof PayrollDetailSetting) =>
    (_: React.SyntheticEvent, data: { value: number | string }) => {
      setPayrollDetailSetting((prev) => ({ ...prev, [field]: data.value }));
    };

  const onKeyDownPercentage = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
    if (allowedKeys.includes(e.key)) {
      return;
    }
    const input = e.currentTarget;
    const { value, selectionStart, selectionEnd } = input;
    const key = e.key;
    if (!/^\d$/.test(key) && key !== ".") {
      e.preventDefault();
      return;
    }
    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }
    const newValue = value.slice(0, selectionStart!) + key + value.slice(selectionEnd!);
    if (!/^\d*\.?\d{0,2}$/.test(newValue)) {
      e.preventDefault();
      return;
    }
    const parsed = parseFloat(newValue);
    if (!isNaN(parsed) && parsed > 100) {
      e.preventDefault();
    }
  };

  const onKeyDownNumberOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Tab"
    ) {
      return;
    }
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const onKeyDownFloatOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];

    const isControlKey = allowedKeys.includes(e.key);
    const isNumberKey = /^[0-9]$/.test(e.key);
    const isDot = e.key === ".";

    const input = e.currentTarget;
    const value = input.value;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    if (isControlKey) {
      return;
    }

    if (isDot && !value.includes(".")) {
      return;
    }

    if (isNumberKey) {
      const dotIndex = value.indexOf(".");

      if (dotIndex === -1) {
        return;
      }

      if (selectionStart <= dotIndex) {
        return;
      }

      const decimalPart = value.substring(dotIndex + 1);

      const isReplacing = selectionStart !== selectionEnd;

      if (decimalPart.length < 2 || isReplacing) {
        return;
      }
    }

    e.preventDefault();
  };

  const handleNumericCommaKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab", ","];
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const [salaryDueDate, setSalaryDueDate] = React.useState(getTodayString());

  useEffect(() => {
    if (
      Array.isArray(props.PayrollSequence?.detailSetting) &&
      props.PayrollSequence.detailSetting.length > 0
    ) {
      const setting = props.PayrollSequence.detailSetting[0];
      setIsInitializing(true);

      setPayrollDetailSetting((prev) => ({
        ...prev,
        tax_id: setting.tax_id ?? "",
        organization_form: setting.organization_form ?? null,
        business_type: setting.business_type ?? null,
        hospital_name_th: setting.hospital_name_th ?? "",
        hospital_name_en: setting.hospital_name_en ?? "",
        hospital_size: setting.hospital_size ?? null,
        emails: setting.emails ?? [],
        mobile_numbers: setting.mobile_numbers ?? [],
        faxs: setting.faxs ?? [],
        website: setting.website ?? "",
        address_th: setting.address_th ?? "",
        address_en: setting.address_en ?? "",
        country: setting.country ?? null,
        province: setting.province ?? null,
        city: setting.city ?? null,
        sub_district: setting.sub_district ?? null,
        postal_code: setting.postal_code ?? "",
        social_security_id: setting.social_security_id ?? "",
        employer_social_security_rate:
          setting.employer_social_security_rate !== null &&
          setting.employer_social_security_rate !== undefined &&
          setting.employer_social_security_rate !== ""
            ? String(setting.employer_social_security_rate)
            : "0.00",
        employee_social_security_rate:
          setting.employee_social_security_rate !== null &&
          setting.employee_social_security_rate !== undefined &&
          setting.employee_social_security_rate !== ""
            ? String(setting.employee_social_security_rate)
            : "0.00",
        employer_maximum_amount:
          setting.employer_maximum_amount !== null &&
          setting.employer_maximum_amount !== undefined &&
          setting.employer_maximum_amount !== ""
            ? String(setting.employer_maximum_amount)
            : "0.00",
        employee_maximum_amount:
          setting.employee_maximum_amount !== null &&
          setting.employee_maximum_amount !== undefined &&
          setting.employee_maximum_amount !== ""
            ? String(setting.employee_maximum_amount)
            : "0.00",
        bank_account_for_pay_run: setting.bank_account_for_pay_run ?? null,
        pay_run_date: setting.pay_run_date ?? null,
        edited_at: setting.edited_at ?? null,
        edited_by: setting.edited_by ?? null,
      }));

      handleFetchUserList(setting.edited_by);

      setTaxIdDigits(setting.tax_id?.split("") ?? Array(13).fill(""));
      setSocialSecurityDigits(setting.social_security_id?.split("") ?? Array(10).fill(""));
      setEmailList(setting.emails ?? []);
      setMobileList(setting.mobile_numbers ?? []);
      setFaxList(setting.faxs ?? []);
      setPostalCode(setting.postal_code ?? "");
      setSelectedBankAccountId(setting.bank_account_for_pay_run ?? null);

      console.log("Loaded detailSetting", setting);
      setIsInitializing(false);
    }
  }, [props.PayrollSequence?.detailSetting]);

  const userList = props.PayrollSequence?.userDetail ?? [];

  useEffect(() => {
    const accountId = payrollDetailSetting.bank_account_for_pay_run;

    if (accountId && props.PayrollSequence?.bankAccount) {
      const matchedAccount = props.PayrollSequence.bankAccount.find(
        (acc: any) => acc.id === accountId
      );

      const rawNumber = matchedAccount?.bank_account_number ?? "";
      const digitsOnly = rawNumber.replace(/\D/g, "");
      setBankAccountDigits(digitsOnly.split("").slice(0, 21));
    }
  }, [payrollDetailSetting.bank_account_for_pay_run, props.PayrollSequence?.bankAccount]);

  useEffect(() => {
    const firstSetting = props.PayrollSequence?.detailSetting?.[0];

    if (firstSetting?.pay_run_date !== null && firstSetting?.pay_run_date !== undefined) {
      const today = new Date();
      const dueDate = new Date(today);
      dueDate.setDate(today.getDate() + firstSetting.pay_run_date);

      const formattedDueDate = dueDate
        .toLocaleDateString("en-GB")
        .split("/")
        .map((part) => part.padStart(2, "0"))
        .join("/");

      setSalaryDueDate(formattedDueDate);
      console.log("Computed salary due date:", formattedDueDate);
    }
  }, [props.PayrollSequence?.detailSetting?.[0]?.pay_run_date]);

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (isInitialized) return;
    const setting = props.PayrollSequence?.detailSetting?.[0];
    if (!setting) return;

    const initLocation = async () => {
      setIsInitializing(true);

      if (setting.country) await handleCountryChange(null, { value: setting.country });
      if (setting.province) await handleProvinceChange(null, { value: setting.province });
      if (setting.sub_district) await handleDistrictChange(null, { value: setting.sub_district });

      if (setting.city) {
        const waitCityList = () =>
          new Promise<void>((resolve) => {
            const interval = setInterval(() => {
              if (props.PayrollSequence?.cityList?.length > 0) {
                clearInterval(interval);
                resolve();
              }
            }, 50);
          });
        await waitCityList();
        await handleCityChange(null, { value: setting.city });
      }

      setIsInitializing(false);
      setIsInitialized(true);
    };

    initLocation();
  }, [props.PayrollSequence?.detailSetting, props.PayrollSequence?.cityList]);

  const editedInfo =
    payrollDetailSetting?.edited_at && payrollDetailSetting?.edited_by
      ? `Last Update: ${moment(payrollDetailSetting.edited_at).format(
          "DD MMM YYYY HH:mm"
        )}\u00A0\u00A0\u00A0\u00A0Update By: ${userList[0]?.full_name}`
      : "";

  console.log("editedInfo: ", editedInfo);

  const editedInformation = editedInfo && (
    <div
      style={{
        backgroundColor: "#fedd9e",
        borderRadius: "6px",
        padding: "5px 15px",
        fontWeight: "bold",
        textAlign: "left",
        minWidth: "250px",
        marginBottom: "5px",
      }}
    >
      {editedInfo}
    </div>
  );

  return (
    <>
      <CardPayrollSettingUX
        renderTaxInputs={() =>
          taxIdDigits.map((digit, index) => {
            const isSpacerIndex = index === 0 || index === 4 || index === 9;
            return (
              <Input
                key={index}
                id={`CardPayrollUX-TaxID-${index}`}
                value={digit}
                onChange={(e) => onChangeTaxId(e, index)}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => onKeyDownTaxId(e, index)}
                style={{
                  width: "40px",
                  textAlign: "center",
                  marginRight: isSpacerIndex ? "20px" : "0",
                }}
                input={{ type: "text", maxLength: 1 }}
              />
            );
          })
        }
        renderSocialSecurityInputs={() => {
          const digits =
            Array.isArray(socialSecurityDigits) && socialSecurityDigits.length === 10
              ? socialSecurityDigits
              : Array(10).fill("");
          return digits.map((digit, index) => {
            const isSpacerIndex = index === 0 || index === 8;
            return (
              <Input
                key={`ssn-${index}`}
                id={`SocialSecurity-Input-${index}`}
                value={socialSecurityDigits[index]}
                onChange={(e) => onChangeSocialSecurity(e, index)}
                onKeyDown={(e: any) => onKeyDownSocialSecurity(e, index)}
                style={{
                  width: "40px",
                  textAlign: "center",
                  marginRight: isSpacerIndex ? "20px" : "0",
                }}
                input={{ type: "text", maxLength: 1 }}
              />
            );
          });
        }}
        renderBankAccountInputs={() => {
          const isBankSelected = selectedBankAccountId !== null;
          const displayDigits = isBankSelected ? bankAccountDigits : Array(10).fill("");
          const isTenDigitAccount = displayDigits.length === 10;

          return displayDigits.map((digit, index) => {
            const isSpacerIndex = isTenDigitAccount && (index === 2 || index === 3 || index === 8);

            return (
              <Input
                key={`bank-${index}`}
                id={`BankAccount-Input-${index}`}
                value={digit}
                onChange={(e) => {
                  if (displayDigits.join("").length >= 20 && e.target.value && digit === "") {
                    return;
                  }
                  onChangeBankAccount(e, index);
                }}
                onKeyDown={(e: any) => onKeyDownBankAccount(e, index)}
                disabled={isBankSelected}
                style={{
                  width: "40px",
                  minWidth: "40px",
                  textAlign: "center",
                  marginRight: isSpacerIndex ? "20px" : "0",
                  backgroundColor: isBankSelected ? "#f0f0f0" : undefined,
                  cursor: isBankSelected ? "not-allowed" : "text",
                }}
                input={{ type: "text", maxLength: 1 }}
              />
            );
          });
        }}
        renderEmailInputs={() => (
          <>
            {emailList.map((email, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
              >
                <label style={{ width: "40px" }}>
                  {props.languageUX === "en" ? "Email" : "อีเมล"}
                </label>
                <Input
                  id={`EmailInput-${index}`}
                  value={email}
                  placeholder="Please fill in Email"
                  style={{ width: "200px", marginRight: "8px" }}
                  onChange={(e) => {
                    const val = e.target.value;
                    const updated = [...emailList];
                    updated[index] = val;
                    setEmailList(updated);
                  }}
                />
                {index === 0 ? (
                  <Button
                    color="green"
                    icon="plus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => setEmailList([...emailList, ""])}
                  />
                ) : (
                  <Button
                    color="red"
                    icon="minus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => {
                      const updated = emailList.filter((_, i) => i !== index);
                      setEmailList(updated);
                    }}
                  />
                )}
              </div>
            ))}
          </>
        )}
        renderFaxInputs={() => (
          <>
            {faxList.map((fax, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
              >
                <label style={{ marginRight: "8px" }}>
                  {props.languageUX === "en" ? "Fax" : "โทรสาร"}
                </label>
                <Dropdown
                  compact
                  placeholder="+66"
                  selection
                  style={{
                    width: "100px",
                    marginRight: "8px",
                    whiteSpace: "normal",
                    fontWeight: "normal",
                  }}
                  value={fax.country_code}
                  options={phoneCountryCodeOptions}
                  onChange={(_, data) => {
                    const updated = [...faxList];
                    updated[index] = { ...fax, country_code: String(data.value) };
                    setFaxList(updated);
                  }}
                />
                <Input
                  id={`FaxInput-${index}`}
                  value={fax.number}
                  maxLength={20}
                  placeholder="Please fill in Fax"
                  style={{ width: "150px", marginRight: "8px" }}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    const updated = [...faxList];
                    updated[index] = { ...fax, number: val };
                    setFaxList(updated);
                  }}
                  onKeyDown={handleNumericCommaKeyDown}
                />
                {index === 0 ? (
                  <Button
                    color="green"
                    icon="plus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => setFaxList([...faxList, { country_code: "", number: "" }])}
                  />
                ) : (
                  <Button
                    color="red"
                    icon="minus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => {
                      const updated = faxList.filter((_, i) => i !== index);
                      setFaxList(updated);
                    }}
                  />
                )}
              </div>
            ))}
          </>
        )}
        renderMobileInputs={() => (
          <>
            {mobileList.map((mobile, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
              >
                <label style={{ width: "100px", marginRight: "8px" }}>
                  {props.languageUX === "en" ? "Mobile Number" : "หมายเลขโทรศัพท์มือถือ"}
                </label>

                <Dropdown
                  compact
                  placeholder="+66"
                  selection
                  style={{
                    width: "100px",
                    marginRight: "8px",
                    whiteSpace: "normal",
                    fontWeight: "normal",
                  }}
                  value={mobile.country_code}
                  options={phoneCountryCodeOptions}
                  onChange={(_, data) => {
                    const updated = [...mobileList];
                    updated[index] = { ...mobile, country_code: String(data.value) };
                    setMobileList(updated);
                  }}
                />

                <Input
                  id={`MobileInput-${index}`}
                  value={mobile.number}
                  maxLength={20}
                  placeholder="Please fill in Mobile Number"
                  style={{ width: "150px", marginRight: "8px" }}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    const updated = [...mobileList];
                    updated[index] = { ...mobile, number: val };
                    setMobileList(updated);
                  }}
                  onKeyDown={handleNumericCommaKeyDown}
                />

                {index === 0 ? (
                  <Button
                    color="green"
                    icon="plus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => setMobileList([...mobileList, { country_code: "", number: "" }])}
                  />
                ) : (
                  <Button
                    color="red"
                    icon="minus"
                    style={{
                      color: "white",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                    onClick={() => {
                      const updated = mobileList.filter((_, i) => i !== index);
                      setMobileList(updated);
                    }}
                  />
                )}
              </div>
            ))}
          </>
        )}
        languageUX={props.languageUX}
        editedInformation={editedInformation}
        renderAddPaymentButton={renderAddPaymentButton}
        taxIdDigits={taxIdDigits}
        organizationFromOptions={organizationFromOptions}
        businessTypeOptions={businessTypeOptions}
        hospitalSizeOptions={hospitalSizeOptions}
        phoneCountryCodeOptions={phoneCountryCodeOptions}
        country={props.masterOptions.country}
        handleCountryChange={handleCountryChange}
        handleProvinceChange={handleProvinceChange}
        handleDistrictChange={handleDistrictChange}
        handleCityChange={handleCityChange}
        provinceList={props.PayrollSequence?.provinceList || []}
        districtList={props.PayrollSequence?.districtList || []}
        cityList={props.PayrollSequence?.cityList || []}
        payRunDateOptions={payRunDateOptions}
        bankAccountData={bankAccountOptions}
        handleBankAccountChange={(e: any, { value }: any) => {
          handleBankAccountChange(e, { value });
          setPayrollDetailSetting((prev) => ({
            ...prev,
            bank_account_for_pay_run: value,
          }));
        }}
        handleOnChangeOrganizationForm={handleOnChangeDropdown("organization_form")}
        handleOnChangeBusinessType={handleOnChangeDropdown("business_type")}
        handleOnChangeHospitalNameTh={handleOnChangeText("hospital_name_th")}
        handleOnChangeHospitalNameEn={handleOnChangeText("hospital_name_en")}
        handleOnChangeHospitalSize={handleOnChangeDropdown("hospital_size")}
        handleOnChangeEmailList={handleOnChangeCommaList("emails")}
        handleOnChangeMobileList={handleOnChangeCommaList("mobile_numbers")}
        handleOnChangeFaxList={handleOnChangeCommaList("faxs")}
        handleOnChangeWebsite={handleOnChangeText("website")}
        handleOnChangeAddressTh={handleOnChangeText("address_th")}
        handleOnChangeAddressEn={handleOnChangeText("address_en")}
        handleOnChangePostalCode={handleOnChangeText("postal_code")}
        handleOnChangeSocialSecurityId={handleOnChangeText("social_security_id")}
        handleOnChangeEmployerSocialRate={handleOnChangePercentage("employer_social_security_rate")}
        handleOnChangeEmployeeSocialRate={handleOnChangePercentage("employee_social_security_rate")}
        handleOnChangeEmployerMaxAmount={handleOnChangeNumber("employer_maximum_amount")}
        handleOnChangeEmployeeMaxAmount={handleOnChangeNumber("employee_maximum_amount")}
        handleOnChangeBankAccountId={handleOnChangeDropdown("bank_account_for_pay_run")}
        handleOnChangePayRunDate={handleOnChangeDropdown("pay_run_date")}
        handleSubmitDetailSetting={handleSubmitDetailSetting}
        handleNumericCommaKeyDown={handleNumericCommaKeyDown}
        onKeyDownNumberOnly={onKeyDownNumberOnly}
        onKeyDownFloatOnly={onKeyDownFloatOnly}
        onKeyDownPercentage={onKeyDownPercentage}
        payrollDetailSetting={payrollDetailSetting}
        setPayrollDetailSetting={setPayrollDetailSetting}
        handleOnClickDetailSetting={(e: any) => {
          const existing = props.PayrollSequence.detailSetting?.[0];

          if (existing) {
            const updatedSetting = {
              ...payrollDetailSetting,
              id: existing.id,
            };

            handleEditDetailSetting(e, { value: null }, updatedSetting);
          } else {
            handleSubmitDetailSetting(e);
          }
        }}
        handleRequiredTaxIDFieldAlert={renderFieldError("tax_id")}
        handleRequiredOrganizationFormFieldAlert={renderFieldError("organization_form")}
        handleRequiredBusinessTypeFieldAlert={renderFieldError("business_type")}
        handleRequiredHospitalNameTHFieldAlert={renderFieldError("hospital_name_th")}
        handleRequiredHospitalNameENFieldAlert={renderFieldError("hospital_name_en")}
        handleRequiredPayRunDateFieldAlert={renderFieldError("pay_run_date")}
        handleSpaceForHospitalSize={
          fieldErrors.business_type && <div style={{ marginLeft: "5px", minWidth: "140px" }} />
        }
      />
      <Modal
        open={openAddPaymentModal}
        onClose={() => {
          setOpenAddPaymentModal(false);
          resetBankAccountFormFields();
          setBankFieldErrors({});
        }}
        size="large"
        style={{ display: "flex", justifyContent: "space-between", whiteSpace: "nowrap" }}
        dimmer="blurring"
        closeIcon
      >
        <Modal.Header style={{ backgroundColor: "transparent", padding: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <div
              style={{
                backgroundColor: "#21ba45",
                color: "white",
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "4px",
                fontWeight: "bold",
              }}
            >
              Add New Payment Method
            </div>
            {localError && <div style={{ color: "red", fontWeight: "bold" }}>{localError}</div>}
          </div>
        </Modal.Header>
        <Modal.Content>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              whiteSpace: "nowrap",
              marginBottom: "20px",
            }}
          >
            <FormField>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: "150px", display: "flex", alignItems: "center" }}>
                  <label style={{ fontWeight: "bold" }}>Bank</label>
                  <label style={{ color: "red", padding: "5px", marginLeft: "4px" }}>*</label>
                </div>
                <Dropdown
                  selection={true}
                  style={{ width: "300px" }}
                  options={bankOptions}
                  value={bank}
                  onChange={(_, { value }) => setBank(value as number)}
                />
              </div>
              <div style={{ marginLeft: "150px", padding: "10px" }}>
                {renderBankFieldError(bankFieldErrors, "bank")}
              </div>
            </FormField>
            <FormField>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: "160px", display: "flex", alignItems: "center" }}>
                  <label style={{ fontWeight: "bold" }}>Bank Account Type</label>
                  <label style={{ color: "red", padding: "5px", marginLeft: "4px" }}>*</label>
                </div>
                <Dropdown
                  selection={true}
                  style={{ width: "300px" }}
                  options={bankAccountTypeOptions}
                  value={bankType}
                  onChange={(_, { value }) => setBankType(value as BankAccountType)}
                />
              </div>
              <div style={{ marginLeft: "150px", padding: "10px 10px 10px 20px" }}>
                {renderBankFieldError(bankFieldErrors, "bank_account_type")}
              </div>
            </FormField>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              whiteSpace: "nowrap",
              marginBottom: "20px",
            }}
          >
            <FormField>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: "150px", display: "flex", alignItems: "center" }}>
                  <label style={{ fontWeight: "bold" }}>Bank Account Name</label>
                  <label style={{ color: "red", padding: "5px", marginLeft: "4px" }}>*</label>
                </div>
                <Input
                  style={{ width: "300px" }}
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
              </div>
              <div style={{ marginLeft: "150px", padding: "10px" }}>
                {renderBankFieldError(bankFieldErrors, "bank_account_name")}
              </div>
            </FormField>
            <FormField>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: "160px", display: "flex", alignItems: "center" }}>
                  <label style={{ fontWeight: "bold" }}>Bank Account Number</label>
                  <label style={{ color: "red", padding: "5px", marginLeft: "4px" }}>*</label>
                </div>
                <Input
                  maxLength={20}
                  style={{ width: "300px" }}
                  value={bankNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,20}$/.test(value)) {
                      setBankNumber(value);
                    }
                  }}
                />
              </div>
              <div style={{ marginLeft: "150px", padding: "10px 10px 10px 20px" }}>
                {renderBankFieldError(bankFieldErrors, "bank_account_number")}
              </div>
            </FormField>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <ButtonLoadCheck
            color="green"
            onClick={handleSubmitBankAccount}
            setProp={props.setProp}
            fluid={false}
            size="medium"
            paramKey={BTN_ACTS.HANDLE_SUBMIT_BANK_ACCOUNT}
            buttonLoadCheck={props.buttonLoadCheck?.[BTN_ACTS.HANDLE_SUBMIT_BANK_ACCOUNT]}
            title="Save"
          />
          <Button
            onClick={() => {
              setOpenAddPaymentModal(false);
              resetBankAccountFormFields();
              setBankFieldErrors({});
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
      <Modal open={showSuccessModal} onClose={() => setShowSuccessModal(false)} size="tiny">
        <Modal.Header
          content="Success"
          style={{ backgroundColor: "#21ba45", color: "white", padding: "16px" }}
        />
        <Modal.Content>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p style={{ fontSize: "20px", marginTop: "20px", marginBottom: "50px" }}>
              Save data success
            </p>
            <Button
              onClick={() => setShowSuccessModal(false)}
              style={{
                border: "1px solid #21ba45",
                color: "#21ba45",
                backgroundColor: "white",
              }}
            >
              Close
            </Button>
          </div>
        </Modal.Content>
      </Modal>
      {showSnack && (
        <SnackMessage
          onEvent={props.onEvent}
          onClose={handleSnackClose}
          error={props.errorMessage?.[CARD_NAME]}
          success={props.successMessage?.[CARD_NAME]}
        />
      )}
    </>
  );
};

export default React.memo(CardPayrollSetting);
